import React from "react";
import { Link } from "react-router-dom";
import { getArchetypeContent } from "@/data/archetypeContent";
import { IDS } from "@/constants/testIds";

export default function ArchetypeCard({ name, tag = "" }) {
  const c = getArchetypeContent(name);
  if (!c) return null;
  return (
    <Link
      to={`/archetype/${encodeURIComponent(name)}`}
      className="pa-card block p-4 md:p-6 transition-transform hover:-translate-y-0.5"
      data-testid={IDS.archetypeCard(c.slug)}
    >
      <div className="flex items-center gap-4">
        <img
          src={c.emblem}
          alt={c.name}
          className="w-14 h-14 md:w-16 md:h-16 object-contain flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          {tag && (
            <div
              className="text-[10px] uppercase tracking-widest mb-1"
              style={{ color: "var(--pa-gold)" }}
            >
              {tag}
            </div>
          )}
          <h3 className="pa-serif text-lg md:text-xl leading-tight" style={{ color: "var(--pa-text-primary)" }}>
            {c.name}
          </h3>
          {c.coreOrientation && (
            <p className="text-xs md:text-sm mt-1" style={{ color: "var(--pa-text-secondary)" }}>
              {c.coreOrientation}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
